import { BaseDTO } from './base-dto';
import { Organization } from './organization';
import { MarketLevel } from './market-level';
import { User } from './user';
import { Module } from './module';
import { UserRoleResource } from './user-role-resource';
import { UserTypeEnum } from '../enums/user-type-enum';
import {RoleActivityTypeEnum} from '../enums/role-activity-type-enum';

export class Subordinate {
    Id: number;
    Index?: string;
    Name: string;
    Rank: number;

}

export class UserRole extends BaseDTO {

    Name: string;
    UserType: UserTypeEnum;
    Organization: Organization;
    MarketLevel: MarketLevel;
    Default: boolean;
    IsApproved: boolean;
    HasSubordinates: boolean;
    ApprovedBy: User;
    ModuleList: Module[];
    UserRoleResourceList: UserRoleResource[];
    UserRoleName: string;
    Rank: number;
    Subordinates: Subordinate[] = [];
    SalesTeam: boolean;
    DcrTeam: boolean;
    RxTeam: boolean;
    RoleActivityType: RoleActivityTypeEnum;
}
